import React from 'react';

import {useLegalInfo} from 'pageflow-scrolled/frontend';

import styles from './Footer.module.css';

import logo from './images/noen.jpg';
import facebookImage from './images/facebook.jpg';
import linkedInImage from './images/linkedIn.jpg';
import instagramImage from './images/instagram.jpg';

export function NoenFooter({name}) {
  const legalInfo = useLegalInfo();

  return (
    <div className={styles.outer}>
      <div className={styles.bar}>
        <a href="https://www.noen.at/">
          <img src={logo} className={styles.logo} alt="NÖN" width="164" height="86" />
        </a>
        <div className={styles.back}>
          <a href="https://www.noen.at/">zurück zu NÖN.at</a>
        </div>

        <div className={styles.social}>
          <a href="https://www.facebook.com/noenat" title="NÖN.at auf Facebook">
            <img src={facebookImage} alt="Facebook" width="40" height="40" />
          </a>
          <a href="https://www.instagram.com/noenachrichten/" title="NÖN.at auf Instagram">
            <img src={instagramImage} alt="Instagram" width="40" height="40" />
          </a>
          <a href="https://www.linkedin.com/company/noennachrichten" title="NÖN.at bei LinkedIn">
            <img src={linkedInImage} alt="LinkedIn" width="40" height="40" />
          </a>
        </div>
        <div className={styles.finePrint}>
          Niederösterreichisches Pressehaus Druck- & Verlags GmbH<br />
          Gutenbergstraße 12, 3100 St. Pölten
        </div>

        <div className={styles.links}>
          <a href={legalInfo.imprint.url}
             target="_blank"
             rel="noreferrer noopener"
             dangerouslySetInnerHTML={{__html: legalInfo.imprint.label}} />
          <a href={legalInfo.privacy.url}
             target="_blank"
             rel="noreferrer noopener"
             dangerouslySetInnerHTML={{__html: legalInfo.privacy.label}} />
        </div>
      </div>
    </div>
  )
}
